module.exports = "https://p.cds.unp.clasificados.pe/logo-trome.a27212b804bce895ea81ab177da21af1.svg";